<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn text @click="tornaIndietro" class="mb-4">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Torna all'elenco
                </v-btn>
            </v-col>
        </v-row>

        <!-- Form dati generali ordine -->
        <FormOrdine ref="formOrdineRef" :ordine="ordine" :loading="loading" @salva="salvaOrdine" />

        <!-- Sezione firma e allegati (solo se ordine esistente) -->
        <v-row class="mt-4">
            <!-- 
            <v-col cols="12" md="6">
                <GestioneFirma :ordine-id="ordine.id" :firma-url="ordine.firmaUrl" @firma-salvata="aggiornaFirma" />
            </v-col>
            -->
            <v-col cols="12" md="6">
                <GestioneAllegati :ordine-id="ordine.Id" :allegati="ordine.Allegati || []"
                    @allegati-aggiornati="aggiornaAllegati" />
            </v-col>
        </v-row>

        <!-- Tabella righe misure (solo se ordine esistente) -->
        <v-row class="mt-4">
            <v-col cols="12">
                <TabellaMisure :ordine-id="ordine.Id" :righe="ordine.Righe || []" @righe-aggiornate="aggiornaRighe" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { get_ordine, crea_ordine, modifica_ordine, get_numero_ordine } from '@/api/api.misure.js'
import FormOrdine from '@/components/ordini/FormOrdine.vue'
/* import GestioneFirma from '@/components/ordini/GestioneFirma.vue' */
import GestioneAllegati from '@/components/ordini/GestioneAllegati.vue'
import TabellaMisure from '@/components/ordini/TabellaMisure.vue'

export default {
    name: 'DettaglioOrdine',

    components: {
        FormOrdine,
        /* GestioneFirma, */
        GestioneAllegati,
        TabellaMisure
    },

    setup() {
        const router = useRouter()
        const route = useRoute()
        const loading = ref(false)
        const formOrdineRef = ref(null)

        const ordine = ref({
            Id: -1,
            NumeroCommessa: '',
            Data: new Date().toISOString().split('T')[0],
        })

        const caricaOrdine = async () => {
            const id = route.params.id
            if (id === 'nuovo') {
                let res = await get_numero_ordine()
                ordine.value.NumeroCommessa = res.data;
                return
            }

            loading.value = true
            try {
                const response = await get_ordine(id)
                ordine.value = response.data || response
            } catch (error) {
                console.error('Errore caricamento ordine:', error)
            }
            loading.value = false
        }

        const salvaOrdine = async (datiOrdine) => {
            loading.value = true
            try {
                if (ordine.value.Id > 0) {
                    await modifica_ordine(ordine.value.Id, datiOrdine)
                } else {
                    const response = await crea_ordine(datiOrdine)
                    ordine.value = response.data || response
                    router.replace({ name: 'DettaglioOrdine', params: { id: ordine.value.Id } })
                }
            } catch (error) {
                console.error('Errore salvataggio ordine:', error)
                alert('Errore durante il salvataggio')
            }
            loading.value = false
        }

        const aggiornaFirma = (firmaUrl) => {
            ordine.value.FirmaUrl = firmaUrl
        }

        const aggiornaAllegati = (allegati) => {
            ordine.value.Allegati = allegati
        }

        const aggiornaRighe = async (righe) => {
            await caricaOrdine();
            ordine.value.Righe = righe
        }

        const tornaIndietro = () => {
            router.push({ name: 'ElencoOrdini' })
        }

        onMounted(() => {
            caricaOrdine()
        })

        return {
            loading,
            ordine,
            formOrdineRef,
            salvaOrdine,
            aggiornaFirma,
            aggiornaAllegati,
            aggiornaRighe,
            tornaIndietro
        }
    }
}
</script>